;(function ($) {

	$(document).ready(function(){
		$('#hamburger').click(function(){
			lockScroll();
			$(this).toggleClass('open');
      $('.menu').slideToggle();
			$('header').toggleClass('menu-open');
    });
		$('.hamburger-to-click').click(function(){
			lockScroll();
			$(this).toggleClass('open');
      $('.menu').slideToggle();
			$('header').toggleClass('menu-open');
    });

		function closeMenu(){
			if($(".hamburger-to-click").hasClass("open") || $("#hamburger").hasClass("open") ){
				// console.log('close');
				$(".hamburger-to-click").removeClass('open');
				$("#hamburger").removeClass('open');
	      $('.menu').slideToggle();
				$('header').removeClass('menu-open');
			} else {
				// console.log("already closed");
			}
		}
		function lockScroll() {
      if ($('body').hasClass('lock-scroll')) {
        $('body').removeClass('lock-scroll');
      } else {
        $('body').addClass('lock-scroll');
      }
    }



		// Select all links with hashes
		$('a[href*="#"]')
			// Remove links that don't actually link to anything
			.not('[href="#"]')
			.not('[href="#0"]')
			.click(function(event) {
				// On-page links
		    closeMenu();
				if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				  // Figure out element to scroll to
				  var target = $(this.hash);
				  target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				  // Does a scroll target exist?
				  if (target.length) {
				    // Only prevent default if animation is actually gonna happen
		      	event.preventDefault();
				    $('html, body').animate({scrollTop: target.offset().top-173}, 1000, function() {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(":focus")) { // Checking if the target was focused
			          return false;
							} else {
				        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
				        $target.focus(); // Set focus again
				      };
				    });
				  }
				}
			});
	});


	$(window).load(function(){


	});


	$(window).resize(function(){


	});

	$(window).scroll(function (event) {
		var scroll = $(window).scrollTop();
		// console.log(scroll);
		if ($(window).width() < 768) {
			// console.log('mobs');
			if(scroll > 100){
				$('header').addClass('scroll');
				$('.logo-on-load').addClass('scroll');
			} else {
				$('header').removeClass('scroll');
				$('.logo-on-load').removeClass('scroll');
			}
		} else {
			// console.log('desktop');
			if(scroll > 84){
				$('header').addClass('scroll');
			} else {
				$('header').removeClass('scroll');
			}
		}
		// if( $('.nav-desktop').css('display')=='none') {
		// 	if(scroll > ){
		// 		$('header').addClass('scroll');
		// 	} else {
		// 		$('header').removeClass('scroll');
		// 	}
   	// } else {
		// 	if(scroll > 84){
		// 		$('header').addClass('scroll');
		// 	} else {
		// 		$('header').removeClass('scroll');
		// 	}
		// }

	});


})(jQuery);
